import { axiosPost } from '@/api/AxiosApi';
import { sendRequest, EndpointPayload } from '@/api/AxiosRequest';
import { CreateStakeDbPoolRequest, CreateStakeDbPositionRequest } from '@/types/stake-db';

const BALANCE_API_URL = process.env.REACT_APP_BALANCE_API_URL;

// 풀 생성
export const createStakeDbPool = async (data: CreateStakeDbPoolRequest) => {
  const payload: EndpointPayload = {
    path: '/assetfi/admin/staking/pools',
    body: data,
    apiUrl: BALANCE_API_URL,
    skipConvert: true,
  };

  return await sendRequest(payload, 'createStakeDbPool', axiosPost);
};

// 수동 스테이킹 등록
export const createStakeDbPosition = async (data: CreateStakeDbPositionRequest) => {
  const payload: EndpointPayload = {
    path: '/assetfi/admin/staking/positions',
    body: data,
    apiUrl: BALANCE_API_URL,
    skipConvert: true,
  };

  return await sendRequest(payload, 'createStakeDbPosition', axiosPost);
};
